# Dev resources & awesome lists
https://github.com/sindresorhus/awesome
https://github.com/EbookFoundation/free-programming-books
https://github.com/public-apis/public-apis
https://github.com/avelino/awesome-go
https://github.com/vinta/awesome-python
https://github.com/rust-unofficial/awesome-rust
https://github.com/sorrycc/awesome-javascript
https://github.com/awesome-selfhosted/awesome-selfhosted
https://github.com/dylanrees/citizen-science
https://github.com/caesar0301/awesome-public-datasets
https://developer.mozilla.org
https://devdocs.io
https://dev.to
https://lobste.rs
https://news.ycombinator.com
https://stackoverflow.com
https://stackexchange.com
https://gitlab.com
https://sourceforge.net
https://codeberg.org
https://sr.ht
https://glitch.com
https://replit.com
https://freecodecamp.org
https://leetcode.com
https://exercism.org
https://codewars.com
https://projecteuler.net
https://rosettacode.org
https://lwn.net
https://jvns.ca
https://danluu.com
https://rachelbythebay.com
https://matklad.github.io
https://fasterthanli.me
https://xeiaso.net
https://christine.website
https://www.joelonsoftware.com
https://blog.codinghorror.com
https://martinfowler.com
https://simonwillison.net
https://antirez.com
https://pointersgonewild.com
https://mcfunley.com
https://blog.samwhomsey.com
